import { createContext, Dispatch, SetStateAction } from 'react';

interface IThemeContext {
    themeName: 'dark' | 'default';
    setTheme: Dispatch<SetStateAction<'dark' | 'default'>>;
}

export const ThemeContext = createContext<Partial<IThemeContext>>({});
